import { AfterViewInit, Component, OnInit, inject, viewChild } from '@angular/core';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { Observable } from 'rxjs';
import { IShopifyCart } from '@app/_shared/_models';
import { CartService } from '../../_shared/_services/cart.service';
import { SidenavService } from './sidenav.service';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatBadge } from '@angular/material/badge';
import { MatNavList, MatListItem } from '@angular/material/list';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    imports: [MatSidenavContainer, MatSidenav, MatIcon, RouterLink, MatIconButton, MatTooltip, MatBadge, MatNavList, MatListItem, MatSidenavContent, AsyncPipe]
})
export class SidenavComponent implements OnInit, AfterViewInit {
  private readonly sidenavService = inject(SidenavService);
  private readonly cartService = inject(CartService);

  public readonly sidenav = viewChild.required<MatSidenav>('sidenav');
  public cart$!: Observable<IShopifyCart | undefined>;

  ngOnInit(): void {
    this.cart$ = this.cartService.cart$;
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav());
  }

  public closeSideNav(): void {
    this.sidenavService.close();
  }

  public openDialog() {
    this.cartService.openDialog();
  }

}
